import { Grid, makeStyles, Typography } from "@material-ui/core";
import { ChevronRightRounded } from "@material-ui/icons";
import Button from "components/Button";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setDemo } from "redux/actions/user";

const useStyles = makeStyles({
  welcome: {
    fontSize: 42,
  },
  title: {
    fontWeight: "bold",
  },
  img: {
    marginTop: 20,
    marginBottom: 20,
  },
  message: {
    lineHeight: "1.25",
    textAlign: "center",
    marginBottom: 40,
  },
  button: {
    width: 264,
    height: 55,
    marginLeft: 10,
  },
});

function Finish() {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <Grid container justify="center" className={classes.img}>
        <img alt="received" src={require("assets/svg/received.svg")} />
      </Grid>
      <Grid container justify="center">
        <Typography className={classes.message}>{t("Messages.While waiting for verification, you may proceed to")} :</Typography>
      </Grid>
      <Grid container justify="center" className={classes.buttonGroup}>
        <Grid item>
          <Link to="/settings">
            <Button variant="outlined" className={classes.button} buttonText={t("Messages.Verify Your Email")} />
          </Link>
        </Grid>
        <Grid item>
          <Link to="/">
            <Button
              className={classes.button}
              endIcon={<ChevronRightRounded />}
              onClick={() => dispatch(setDemo(true))}
              buttonText={t("Labels.Go to Demo Mode")}
            />
          </Link>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Finish;
